export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_08.14a697cc.jpg";